// extracted by mini-css-extract-plugin
export default {"participants-info":"ParticipantsInfo_participants-info__9L6co"};